<template>
	<div class="media-viewer-container">
		<div class="videos" v-if="isVideo" v-show="showVideoViewer">
			<div class="video-viewer-overlay" @click="closeVideoViewer">
				<div class="video-viewer-content" @click.stop>
					<video
						ref="videoPlayer"
						class="video-player"
						:src="message.attachment_url"
						controls
						preload="metadata"
						@loadedmetadata="handleVideoLoaded"
						@error="handleVideoError"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "ChatVideoViewer",

	data() {
		return {
			message: {},
			showVideoViewer: false,
			videoDuration: 0,
		};
	},

	computed: {
		isVideo() {
			if (this.message.type === 8) return true;
			if (!this.message.attachment_url) return false;
			const extension = this.getFileExtension().toLowerCase();
			return ["mp4"].includes(extension);
		},
	},

	methods: {
		getFileExtension() {
			if (!this.message.attachment_url) return "";
			const url = this.message.attachment_url.split("?")[0];
			const parts = url.split(".");
			return parts.length > 1 ? parts.pop() : "";
		},

		showViewer() {
			this.showVideoViewer = true;
			this.addVideoKeydownListener();
		},
		videoViewer(message, conversationObjectId) {
			this.message = message;
			this.conversationObjectId = conversationObjectId;
			this.$nextTick(() => {
				this.showViewer();
			});
		},

		addVideoKeydownListener() {
			document.addEventListener("keydown", this.handleKeydown);
		},
		removeVideoKeydownListener() {
			document.removeEventListener("keydown", this.handleKeydown);
		},

		handleKeydown(e) {
			if (e.keyCode === 27 && this.showVideoViewer) {
				// ESC 关闭
				this.closeVideoViewer();
			}
		},

		closeVideoViewer() {
			this.showVideoViewer = false;
			this.removeVideoKeydownListener();
			if (this.$refs.videoPlayer) {
				this.$refs.videoPlayer.pause();
			}
		},

		handleVideoLoaded() {
			if (this.$refs.videoPlayer) {
				this.videoDuration = this.$refs.videoPlayer.duration;
			}
		},

		handleVideoError() {
			// this.$message.error(this.$t("avatar.uploadFailed"));
		},
	},

	beforeDestroy() {
		this.removeVideoKeydownListener();
	},
};
</script>

<style lang="less" scoped>
.media-viewer-container {
	.videos {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 2500;
	}

	.video-viewer-overlay {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	.video-viewer-content {
		position: relative;
		max-width: 90vw;
		max-height: 90vh;
		cursor: default;
	}

	.video-player {
		max-width: 100%;
		max-height: 80vh;
		background-color: #000;
		border-radius: 8px;
	}
}

@media (max-width: 768px) {
	.video-viewer-content {
		max-width: 95vw;
		max-height: 95vh;
	}
}
</style>

<style>
/* 确保视频查看器在最顶层 */
.video-viewer-overlay {
	z-index: 2500 !important;
}
</style>
